export const freshworksLogoutUrl =
  "https://chamberperksapp.freshdesk.com/logout";
export const freshworksLoginUrl =
  "https://chamberperksapp.freshdesk.com/customer/login";
